<div
  class="table-sport__subhead d-flex align-items-center bg-light"
  (click)="openStage(stage.id)"
  [attr.data-toggle]="stage.participants && stage.participants.length !== 0 && stage.valueTypes ? 'collapse' : null"
  [attr.data-target]="'#collapse-stage-' + stage.id"
  role="button"
  [attr.aria-expanded]="stage.expand || isStageOpen(stage.id)"
  [class.collapsed]="!(stage.expand || isStageOpen(stage.id))"
  [attr.aria-controls]="'collapse-stage-' + stage.id"
  >
  @if (stage.parent_iso) {
    <img
      src="/img/flags/1x1/{{ stage.parent_iso | lowercase }}.svg"
      alt=""
      width="20"
      class="mr-2 rounded-circle"
      />
  }
  @if (!stage.parent_iso) {
    <img src="img/sports/{{ sportName }}.png" alt="" width="20" class="mr-2 rounded-circle" />
  }
  <div class="table-sport__subhead__text mb-0 text-uppercase text-truncate">
    @if (deviceService.isMobile()) {
      <span [class.status-cancelled]="stage.status === 'Cancelled'">
        {{ stage.parent_description }}
        <div class="text-muted mt-1">
          @if (showDate) {
            {{ stage.startDate | livDate : 'localDate' }}
          }
          {{ stage.description }} - {{ stage.startDate | livDate : 'localTime' }}
        </div>
      </span>
      @if (stage.status) {
        <strong class="text-emph">{{ 'web.status-' + stage.status | lowercase | translate }}</strong>
      }
    }
    @if (!deviceService.isMobile()) {
      <span [class.status-cancelled]="stage.status === 'Cancelled'">
        @if (stage.parent_description) {
          {{ stage.parent_description }} -
          }{{ stage.description }} -
          @if (showDate) {
            {{ stage.startDate | livDate : 'localDate' }}
          }
          {{ stage.startDate | livDate : 'localTime' }}
        </span>
        @if (stage.status) {
          -
          <strong class="text-emph">{{ 'web.status-' + stage.status | lowercase | translate }}</strong>
        }
      }
      @if (pageService.debug) {
        ({{ stage.id }})
      }

      <div class="text-muted mt-1">
        @if (stage?.stageInfos?.weather) {
          <span>
            {{ 'web.weather' | translate }}:
            <strong>{{ 'web.' + stage.stageInfos.weather | lowercase | translate }}</strong> &nbsp;&nbsp;
          </span>
        }
        @if (stage?.stageInfos?.air_temperature) {
          <span>
            {{ 'web.air_temperature' | translate }}:
            <strong>{{ stage.stageInfos.air_temperature }}°C</strong> &nbsp;&nbsp;
          </span>
        }
        @if (stage?.stageInfos?.track_temperature) {
          <span>
            {{ 'web.track_temperature' | translate }}:
            <strong>{{ stage.stageInfos.track_temperature }}°C</strong> &nbsp;&nbsp;
          </span>
        }
      </div>
    </div>
    <!-- <svg class="icon icon--12 mx-2"><use href="#icon-heart"/></svg> -->
    <div class="ml-auto">
      @if (pageService.debug) {
        <a [href]="pageService.backofficeHost + '/stages/edit/' + stage.id" target="blank" title="Administration">
          <i class="fas fa-user-shield"></i
          ></a>
        }
        @if (stage.hasVideo && !deviceService.isMobile()) {
          <a
            (click)="openVideo($event, stage)"
            data-toggle="tooltip"
            data-placement="top"
            data-cy="match-stream"
            title="{{ 'web.stream_channel' | translate }}"
            >
            <svg class="icon icon--12 icon--stream">
              <use xlink:href="#icon-stream" />
            </svg>
          </a>
        }
        @if (sportId && sportName && showEventDetailBtn) {
          <a
            [routerLink]="['/page/stage/event', sportName + '-' + sportId, stage.parent_id]"
            (click)="closeAllStages()"
            class="ml-2 small text-reset app-stage-icon app-custom-link"
            >
            {{ 'web.event-detail' | translate }}
          </a>
        }
      </div>
    </div>
    @if (
      (stage.expand || isStageOpen(stage.id)) &&
      stage.participants &&
      stage.participants.length !== 0 &&
      stage.valueTypes
      ) {
      <div
        class="collapse"
        [class.show]="stage.expand || isStageOpen(stage.id)"
        [attr.id]="'collapse-stage-' + stage.id"
        >
        <div class="w-100 mt-3 mb-5">
          @if (stage.participants[1] && stage.participants[1].length > 0) {
            <app-stage-table
              [participants]="stage.participants[1]"
              [valueTypes]="stage.valueTypes.competitors"
              [stage]="stage"
              [sportName]="sportName"
              [sportId]="sportId"
            ></app-stage-table>
          }
          @if (stage.participants[2] && stage.participants[2].length > 0) {
            <app-stage-table
              [participants]="stage.participants[2]"
              [valueTypes]="stage.valueTypes.teams"
              [stage]="stage"
              [sportName]="sportName"
              [sportId]="sportId"
            ></app-stage-table>
          }
        </div>
      </div>
    }
